export default "__VITE_ASSET__DOn3KbS9__"